module.exports = __webpack_public_path__ + "static/media/93.6ae1e017.jpg";